import React, { useState, useEffect } from "react";
import AuthInterceptor from "../../interceptors/authInterceptor.jsx";
import Layout from "../../components/layout/AdminLayout.jsx";
import { generateClient } from "aws-amplify/data";

const client = generateClient();

function ContactInfoForm() {
  const [contactInfo, setContactInfo] = useState({
    address: "",
    phone: "",
    email: "",
    lat: 0,
    lng: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContactInfo = async () => {
      setLoading(true);
      try {
        const { data: items } = await client.models.ContactInfo.list({
          authMode: "userPool",
        });
        if (items.length > 0) {
          setContactInfo(items[0]); // Usar el primer registro
        }
      } catch (error) {
        console.error("Error al obtener información de contacto:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchContactInfo();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContactInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (contactInfo.id) {
        // Actualizar la información existente
        const contactoResult = await client.models.ContactInfo.update(
          contactInfo,
          {
            authMode: "userPool",
          },
        );
      } else {
        // Crear una nueva entrada si no existe
        const contactoResult = await client.models.ContactInfo.create(
          contactInfo,
          {
            authMode: "userPool",
          },
        );
      }
    } catch (error) {
      console.error("Error al actualizar la información:", error);
      alert("Error al actualizar la información.");
    }
  };

  if (loading) return <div>Cargando información...</div>;

  return (
    <Layout>
      <AuthInterceptor>
        <form
          onSubmit={handleSubmit}
          className="space-y-4 rounded-lg bg-white p-6 shadow-lg"
        >
          <h2 className="text-2xl font-bold text-gray-800">
            Actualizar Información de Contacto
          </h2>
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Dirección
            </label>
            <input
              type="text"
              name="address"
              value={contactInfo.address}
              onChange={handleChange}
              className="block w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:border-indigo-500 focus:ring-indigo-500"
            />
          </div>
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Teléfono
            </label>
            <input
              type="text"
              name="phone"
              value={contactInfo.phone}
              onChange={handleChange}
              className="block w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:border-indigo-500 focus:ring-indigo-500"
            />
          </div>
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Correo Electrónico
            </label>
            <input
              type="email"
              name="email"
              value={contactInfo.email}
              onChange={handleChange}
              className="block w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:border-indigo-500 focus:ring-indigo-500"
            />
          </div>
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Latitud
            </label>
            <input
              type="text"
              name="lat"
              value={contactInfo.lat}
              onChange={handleChange}
              className="block w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:border-indigo-500 focus:ring-indigo-500"
            />
          </div>
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Longitud
            </label>
            <input
              type="text"
              name="lng"
              value={contactInfo.lng}
              onChange={handleChange}
              className="block w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:border-indigo-500 focus:ring-indigo-500"
            />
          </div>
          <button
            type="submit"
            className="w-full rounded-lg bg-indigo-600 px-4 py-2 font-semibold text-white shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Guardar Cambios
          </button>
        </form>
      </AuthInterceptor>
    </Layout>
  );
}

export default ContactInfoForm;
